import { Plugins } from '@leverege/plugin';
function getSeriesFor(objectType) {
  const filter = series => {
    if (series.objectType == null) {
      return true;
    }
    if (typeof series.objectType === 'string') {
      return series.objectType === objectType;
    }
    if (Array.isArray(series.objectType)) {
      return series.objectType.includes(objectType);
    }
    if (typeof series.objectType === 'function') {
      return series.objectType(objectType);
    }
    return false;
  };
  return Plugins.createView('SeriesModel', {
    filter
  }).get();
}
export default {
  getSeriesFor
};